module.exports = __webpack_public_path__ + "static/img/10areaB_08.4935b24.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_08.png
// module id = 1087
// module chunks = 1